export const JOURNEY_SOURCE_TYPE = {
  HUBSPOT_OBJECT: 'HUBSPOT_OBJECT',
  HUBSPOT_EVENT: 'HUBSPOT_EVENT'
};